/** URL that lands on the dashboard with the upgrade modal open (old /upgrade and /access-expired links redirect here). */
export const UPGRADE_MODAL_URL = "/dashboard?upgrade=1";

let opener: (() => void) | null = null;

/** Called by the private-routes layout, which renders the upgrade modal. */
export function registerUpgradeModalOpener(open: (() => void) | null) {
  opener = open;
}

export function openUpgradeModal() {
  if (opener) {
    opener();
    return;
  }
  window.location.assign(UPGRADE_MODAL_URL);
}
